export const isAdminUser = (user) =>
  Boolean(
    user
    && (user.role === 'superadmin' || user.role?.startsWith('admin_') || user.role === 'admin')
  );

/** admin_level_1 = super admin (all locations); admin_illinois etc. = one state only. */
export const isSuperAdminUser = (user) =>
  Boolean(user && (user.role === 'admin_level_1' || user.role === 'superadmin'));

export const isEmployeeUser = (user) => Boolean(user && user.role === 'employee');

export const getPostLoginPath = (user) => (isEmployeeUser(user) ? '/my-registration' : '/dashboard');
